import type { FeatureEvents, ScreenEvent, UIEvent } from '../new-analytics-types';
import { Action, ActionSubject } from '../new-analytics-types';

type ScreenKeys = 'governanceManagerScreen';

type UIEventKeys =
  | 'clickedGovernanceManagerLearnMoreLink'
  | 'clickedGovernanceManagerComplianceLink'
  | 'clickedGovernanceManagerAppDetailsExpandToggle'
  | 'clickedGovernanceManagerActionReasonLink';

type TrackEventKeys = string;

type OperationalEventKeys = string;

export const governanceManagerScreen = 'governanceManagerScreen';

export const governanceManagerEvents: FeatureEvents<ScreenKeys, UIEventKeys, TrackEventKeys, OperationalEventKeys> = {
  confluenceSpec: 'https://hello.atlassian.net/wiki/spaces/ETF/pages/5480056418/Compliance+Manager+M1+Analytics+Spec',
  screen: {
    governanceManagerScreen: (attributes: { isEmpty?: boolean }): ScreenEvent => ({
      data: {
        name: governanceManagerScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/85623',
    }),
  },
  ui: {
    clickedGovernanceManagerLearnMoreLink: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Link,
        actionSubjectId: 'governanceManagerLearnMoreLink',
        source: governanceManagerScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/85624',
    }),
    clickedGovernanceManagerComplianceLink: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Link,
        actionSubjectId: 'governanceManagerComplianceLink',
        source: governanceManagerScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/85625',
    }),
    clickedGovernanceManagerAppDetailsExpandToggle: (attributes: { isExpanded: boolean; workspaceAri: string }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'governanceManagerComplianceAppDetailsExpandToggle',
        source: governanceManagerScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/85625',
    }),
    clickedGovernanceManagerActionReasonLink: (attributes: { frameworkType: string; href: string }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Link,
        actionSubjectId: 'governanceManagerActionReasonLink',
        source: governanceManagerScreen,
        attributes,
      },
    }),
  },
  track: {},
  operational: {},
};
